/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Large_Json_Files_Faq_A3Inputs */

const en_guide_large_json_files_faq_a3 = /** @type {(inputs: Guide_Large_Json_Files_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It depends on available memory rather than a fixed limit. Files up to a few hundred megabytes are usually fine on a modern machine, but rendering all of it at once is what tends to freeze a tab, not the parsing itself.`)
};

const ko_guide_large_json_files_faq_a3 = /** @type {(inputs: Guide_Large_Json_Files_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`정해진 한계보다 가용 메모리에 달려 있습니다. 요즘 기기에서는 수백 메가바이트까지 대체로 괜찮지만, 탭을 멈추게 하는 것은 파싱 자체가 아니라 전체를 한 번에 렌더링하는 일입니다.`)
};

const ja_guide_large_json_files_faq_a3 = /** @type {(inputs: Guide_Large_Json_Files_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`決まった上限よりも利用可能なメモリに依存します。最近の端末では数百メガバイトまでたいてい問題ありませんが、タブを固まらせるのはパース自体ではなく、全体を一度に描画することです。`)
};

/**
* | output |
* | --- |
* | "It depends on available memory rather than a fixed limit. Files up to a few hundred megabytes are usually fine on a modern machine, but rendering all of it a..." |
*
* @param {Guide_Large_Json_Files_Faq_A3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_large_json_files_faq_a3 = /** @type {((inputs?: Guide_Large_Json_Files_Faq_A3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Large_Json_Files_Faq_A3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_large_json_files_faq_a3(inputs)
	if (locale === "ko") return ko_guide_large_json_files_faq_a3(inputs)
	return ja_guide_large_json_files_faq_a3(inputs)
});